import { render } from "./mobile_draw_field.vue?vue&type=template&id=71223b4e"
import script from "./mobile_draw_field.vue?vue&type=script&lang=js"
export * from "./mobile_draw_field.vue?vue&type=script&lang=js"

import exportComponent from "/home/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/mobile_draw_field.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71223b4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71223b4e', __exports__)) {
    api.reload('71223b4e', __exports__)
  }
  
  module.hot.accept("./mobile_draw_field.vue?vue&type=template&id=71223b4e", () => {
    api.rerender('71223b4e', render)
  })

}


export default __exports__